import React from 'react';
import { Grid, Label, Form, TextArea, Dropdown } from 'semantic-ui-react';
import InputField from 'common/InputField';
import ScriptEditor from './ScriptEditor';
import { targetTypesOptions, gainTypesOptions, statTypesOptions } from 'common/options';


const SkillEditor = function(props) {
  const skill = props.skill;
  const change = props.onChange;

  return (
  <React.Fragment>
    <Grid.Row>
      <Grid.Column width={16}>
        <Form>
          <Label>Description</Label>
          <TextArea value={skill.Description}
                    onChange={(e,d) => change('Description')(d.value)}
                    placeholder='Skill Description'/>
        </Form>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={4}>
        <Label>Required stat</Label>
        <Dropdown selection
                  fluid
                  options={statTypesOptions}
                  value={skill.RequiredStat}
                  onChange={(e,d) => change('RequiredStat')(d.value)}
                  />
      </Grid.Column>
      <Grid.Column width={4}>
        <InputField value={skill.RequiredValue}
                    onChange={change('RequiredValue')}
                    label='Required value'
                    placeholder='Required value'
                    fluid
                    type='int' />
      </Grid.Column>
      <Grid.Column width={4}>
        <Label>Gain</Label>
        <Dropdown selection
                  fluid
                  options={gainTypesOptions}
                  value={skill.Gain}
                  onChange={(e,d) => change('Gain')(d.value)} />
      </Grid.Column>
      <Grid.Column width={4}>
        <InputField value={skill.Cooldown}
                    onChange={change('Cooldown')}
                    label='Cooldown'
                    placeholder='Cooldown'
                    fluid
                    type='int' />
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={4}>
        <Label>Target type</Label>
        <Dropdown selection
                  fluid
                  options={targetTypesOptions}
                  value={skill.TargetType}
                  onChange={(e,d) => change('TargetType')(d.value)} />
      </Grid.Column>
      <Grid.Column width={12}>
        <Label>OnUse</Label>
        <ScriptEditor src={skill.OnUse}
                      onSave={change('OnUse')} />
      </Grid.Column>
    </Grid.Row>
  </React.Fragment>
  );
}



export default SkillEditor;
